(function () {
  if (window.swxLoad3D) return;
  var pending;
  function addScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function () { reject(new Error('swapex: failed to load ' + src)); };
      document.head.appendChild(s);
    });
  }
  window.swxLoad3D = function (el) {
    if (pending) return pending;
    var d = el.dataset;
    pending = addScript(d.three)
      .then(function () { return Promise.all([addScript(d.env), addScript(d.gltf)]); })
      .then(function () {
        window.__airpods = new Promise(function (resolve, reject) {
          new THREE.GLTFLoader().load(d.glb, resolve, undefined, reject);
        });
        return window.__airpods;
      });
    return pending;
  };
})();
